import posthog from 'posthog-js'

if (import.meta.env.VITE_POSTHOG_API_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
    // api_host is a reverse proxy on our own domain, so ui_host must be stated
    // explicitly: posthog-js otherwise derives it from api_host and the toolbar
    // and in-app links resolve to a host that can't serve them.
    ui_host: 'https://us.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    session_recording: {
      recordCrossOriginIframes: false,
    },
  })
}

export default posthog
